import { adminPartnerQueryKeys as e } from "./useAdminPartnerQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminPartnersApi as n } from "@maat/api-main";
//#region src/partners/admin/useAdminPartnerFraudFlagsQuery.ts
var r = (r) => t({
	queryKey: e.fraudFlags(),
	queryFn: () => n.fraudFlags(),
	enabled: r?.enabled ?? !0
});
//#endregion
export { r as useAdminPartnerFraudFlagsQuery };
